/*
# -----------------------------------------------------------------------------
#	Project: HSE Genius®
#	Client ID: 834215
#	Registration Code: IT-2025-ZR319-MQ744
#	Author: KaimakiWeb
#	Website: https://kaimakiweb.com
#	Copyright (c) 2024-2026 Kaimaki Web. All rights reserved.
#
#	This software and its source code are the property of KaimakiWeb.
#	Unauthorized copying, modification, distribution, or use of this software,
#	via any medium, is strictly prohibited unless prior written permission
#	is obtained from KaimakiWeb.
# -----------------------------------------------------------------------------
*/

import ApiService from "../api-service";

class CommonApiService extends ApiService {
  checkTaskStatus = async (taskId) =>
    await this.get(`/task_status/${taskId}`, null, false, {
      headers: {
        Accept: "text/event-stream",
      },
      responseType: "stream",
      adapter: "fetch",
    });

  getCountryCodes = async () =>
    await this.get("/country-code").then((res) => res.data);

  /**
   * Report a frontend error (e.g. from Error Boundary). Sends email to support@kaimakiweb.com.
   * Fire-and-forget; does not throw.
   */
  reportFrontendError = (payload) => {
    const { page, message, stack, component_stack, username, browser } = payload || {};
    if (!page || !message) return Promise.resolve();
    return this.post("/frontend-error", {
      page: String(page),
      message: String(message),
      ...(stack != null && { stack: String(stack) }),
      ...(component_stack != null && { component_stack: String(component_stack) }),
      ...(username != null && username !== "" && { username: String(username) }),
      ...(browser != null && browser !== "" && { browser: String(browser) }),
    }).catch(() => {});
  };
}

export const CommonApi = new CommonApiService("common");
